import FormFields from "constants/formFields";

export function getPrePaymentFormFieldsForEntity(entity) {

    const fieldObj = FormFields.prePaymentForm;

    let fields = [];

    if(entity.isPremiumContent) {
        // Note: not required yet
    } else if(entity.isOneToOneMeeting) {
        if(!entity.data.meta.allow_guests) {
            fields = fieldObj.one_to_one_meeting.filter(field => field!=="guest_emails");
        } else {
            fields = fieldObj.one_to_one_meeting;
        }
    } else if(entity.isRegularChannel) {
        // Note: not required yet
    } else if(entity.isCourse) {
        // Note: not required yet
    }

    return fields;
}